// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[8].use[1]!../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[8].use[2]!../../../../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[8].use[3]!../../../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[8].use[4]!../../../../../../node_modules/antd/dist/reset.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.AcademicInformation_App__LCqF8 {
  width: 100%;
}

/* Global Toast / Message enhancements */
.AcademicInformation_ant-message__dCBaR {
  top: 72px !important;
  z-index: 99999 !important;
}
.AcademicInformation_ant-message__dCBaR .AcademicInformation_ant-message-notice-content__JRWRr {
  border-radius: 10px !important;
  padding: 10px 18px !important;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.08) !important;
  font-size: 13.5px !important;
  font-weight: 500 !important;
}

.AcademicInformation_ant-notification__K\\+uhl {
  top: 72px !important;
  z-index: 99999 !important;
}

/* Standalone Toast Keyframes */
@keyframes AcademicInformation_toast-progress__BSIca {
  from {
    width: 100%;
  }
  to {
    width: 0%;
  }
}
@keyframes AcademicInformation_toast-slide-in__FURUu {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.AcademicInformation_animate-toast-in__2WakJ {
  animation: AcademicInformation_toast-slide-in__FURUu 0.22s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.AcademicInformation_academic-information__JAETu {
  display: flex;
  flex-direction: column;
}

.AcademicInformation_tabs-mobile__wrapper__2o-lj {
  box-shadow: rgba(0, 0, 0, 0.25) 0px 0px 10px 0px;
  border-radius: 10px;
}
.AcademicInformation_tabs-mobile__wrapper__2o-lj .ant-tabs-nav {
  border-radius: 10px 10px 0 0;
  overflow: hidden;
}
.AcademicInformation_tabs-mobile__wrapper__2o-lj .ant-tabs-nav-operations {
  display: none !important;
}
.AcademicInformation_tabs-mobile__wrapper__2o-lj .ant-tabs-tab {
  z-index: 1;
  padding: 12px 16px;
  margin: 0 !important;
}
.AcademicInformation_tabs-mobile__wrapper__2o-lj .ant-tabs-tabpane {
  padding: 0 16px !important;
}
.AcademicInformation_tabs-mobile__wrapper__2o-lj .ant-tabs-nav-wrap::before {
  box-shadow: none !important;
  content: "‹" !important;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, rgb(255, 255, 255) 25%, rgba(255, 255, 255, 0) 100%);
}
.AcademicInformation_tabs-mobile__wrapper__2o-lj .ant-tabs-nav-wrap::after {
  box-shadow: none !important;
  content: "›" !important;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(-90deg, rgb(255, 255, 255) 25%, rgba(255, 255, 255, 0) 100%);
}

@media only screen and (max-width: 480px) {
  .AcademicInformation_academic-information__JAETu {
    gap: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/VenueDetail/Components/AcademicInformation/AcademicInformation.module.scss","webpack://./src/App.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACChB;EACE,WAAA;ADEF;;ACgFA,wCAAA;AACA;EACE,oBAAA;EACA,yBAAA;AD7EF;AC+EE;EACE,8BAAA;EACA,6BAAA;EACA,+FAAA;EACA,4BAAA;EACA,2BAAA;AD7EJ;;ACiFA;EACE,oBAAA;EACA,yBAAA;AD9EF;;ACiFA,+BAAA;AACA;EACE;IACE,WAAA;ED9EF;ECgFA;IACE,SAAA;ED9EF;AACF;ACiFA;EACE;IACE,UAAA;IACA,wCAAA;ED/EF;ECiFA;IACE,UAAA;IACA,iCAAA;ED/EF;AACF;ACkFA;EACE,iGAAA;ADhFF;;AA3CA;EACE,aAAA;EACA,sBAAA;AA8CF;;AA1CE;ECFA,gDAAA;EACA,mBAAA;ADgDF;AC9CE;EACE,4BAAA;EACA,gBAAA;ADgDJ;AC7CE;EACE,wBAAA;AD+CJ;AC5CE;EACE,UAAA;EACA,kBAAA;EACA,oBAAA;AD8CJ;AC3CE;EACE,0BAAA;AD6CJ;AC1CI;EACE,2BAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uFAAA;AD4CN;ACrCI;EACE,2BAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wFAAA;ADuCN;;AA3EA;EACE;IACE,SAAA;EA8EF;AACF","sourcesContent":["@import \"App.scss\";\n\n.academic-information {\n  display: flex;\n  flex-direction: column;\n}\n\n.tabs-mobile {\n  &__wrapper {\n    @include antd-tab-mobile-wrapper;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .academic-information {\n    gap: 12px;\n  }\n}\n","@import \"antd/dist/reset.css\";\n.App {\n  width: 100%;\n}\n\n@mixin antd-tab-mobile-wrapper {\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 0px 10px 0px;\n  border-radius: 10px;\n\n  :global(.ant-tabs-nav) {\n    border-radius: 10px 10px 0 0;\n    overflow: hidden;\n  }\n\n  :global(.ant-tabs-nav-operations) {\n    display: none !important;\n  }\n\n  :global(.ant-tabs-tab) {\n    z-index: 1;\n    padding: 12px 16px;\n    margin: 0 !important;\n  }\n\n  :global(.ant-tabs-tabpane) {\n    padding: 0 16px !important;\n  }\n  :global(.ant-tabs-nav-wrap) {\n    &::before {\n      box-shadow: none !important;\n      content: \"\\2039\" !important;\n      font-size: 20px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: linear-gradient(\n        90deg,\n        rgb(255, 255, 255) 25%,\n        rgba(255, 255, 255, 0) 100%\n      );\n    }\n\n    &::after {\n      box-shadow: none !important;\n      content: \"\\203A\" !important;\n      font-size: 20px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: linear-gradient(\n        -90deg,\n        rgb(255, 255, 255) 25%,\n        rgba(255, 255, 255, 0) 100%\n      );\n    }\n  }\n}\n\n@mixin mui-tab-mobile-wrapper {\n  padding: 16px;\n  background: #fff;\n  border: 1px solid var(--light-grey);\n  border-radius: 10px;\n  :global(.MuiTabs-root) {\n    position: relative;\n\n    :global(.MuiTabScrollButton-root) {\n      position: absolute;\n      top: 0;\n      height: 100%;\n      background-color: white;\n      z-index: 1;\n\n      &:first-child {\n        left: 0;\n      }\n\n      &:last-child {\n        right: 0;\n      }\n    }\n  }\n}\n\n/* Global Toast / Message enhancements */\n.ant-message {\n  top: 72px !important;\n  z-index: 99999 !important;\n\n  .ant-message-notice-content {\n    border-radius: 10px !important;\n    padding: 10px 18px !important;\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.08) !important;\n    font-size: 13.5px !important;\n    font-weight: 500 !important;\n  }\n}\n\n.ant-notification {\n  top: 72px !important;\n  z-index: 99999 !important;\n}\n\n/* Standalone Toast Keyframes */\n@keyframes toast-progress {\n  from {\n    width: 100%;\n  }\n  to {\n    width: 0%;\n  }\n}\n\n@keyframes toast-slide-in {\n  from {\n    opacity: 0;\n    transform: translateY(-10px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.animate-toast-in {\n  animation: toast-slide-in 0.22s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"App": `AcademicInformation_App__LCqF8`,
	"ant-message": `AcademicInformation_ant-message__dCBaR`,
	"ant-message-notice-content": `AcademicInformation_ant-message-notice-content__JRWRr`,
	"ant-notification": `AcademicInformation_ant-notification__K+uhl`,
	"animate-toast-in": `AcademicInformation_animate-toast-in__2WakJ`,
	"toast-slide-in": `AcademicInformation_toast-slide-in__FURUu`,
	"academic-information": `AcademicInformation_academic-information__JAETu`,
	"tabs-mobile__wrapper": `AcademicInformation_tabs-mobile__wrapper__2o-lj`,
	"toast-progress": `AcademicInformation_toast-progress__BSIca`
};
export default ___CSS_LOADER_EXPORT___;
